module.exports = __webpack_public_path__ + "img/mile6m.160e1db5.webp";